import {Button, Stack} from "react-bootstrap";
import {AdminUserAlert, FileUpload, OurClearAlert, PageTitle, SingleText} from "../../_components";
import React from "react";
import {Link, useNavigate, useParams} from "react-router-dom";
import {useAuth} from "../../../context";
import {useGetJson, useGetJsonDirect, usePostGeneric} from "../../../hooks";
import {endpoints} from "../../../utils2";
import {Formik, Form as FormikForm} from "formik";
import * as yup from "yup";
import {AvailableSpaceBar} from "./AvailableSpaceBar";
import {WhiteCard} from "../../device/_components/WhiteCard";


export function AddEditAnnouncement() {
    const {uid, aid} = useParams()
    const {authToken} = useAuth()
    const navigate = useNavigate();

    const edit = aid !== "add"

    const [annsDet, loadingAnDetails, errorAnDetails, clearErrorAnDetails] = useGetJson(aid === "add" ? null : endpoints.announcement.get(uid, aid), authToken?.jwt)
    const announcementDetails = annsDet?.data

    const [submitFormAdd, _, loadingAdd, errorAdd, clearErrorAdd] = usePostGeneric(endpoints.announcement.add(uid), authToken?.jwt)

    const [submitFormEdit, _2, loadingEdit, errorEdit, clearErrorEdit] = usePostGeneric(endpoints.announcement.edit(uid, aid), authToken?.jwt)

    const [anSize, loadingAnSize, errorAnSize, clearErrorAnSize] = useGetJson(endpoints.announcement.size(uid), authToken?.jwt)
    const announcementSize = anSize?.data || 0

    const {value: fileLim, error: fileLimitError, clearError: fileLimitClearError} = useGetJsonDirect(endpoints.announcement.limit(), authToken?.jwt)
    const fileLimitInMB = fileLim?.file_limit || 0

    const [subListF, loadingSubListF, errorSubListF, clearErrorSubListF] = useGetJson(endpoints.subscription.filter(uid), authToken?.jwt)
    const subscriptionListFiltered = subListF?.data

    const loading = loadingAnDetails || loadingAnSize || loadingAdd || loadingEdit

    const validationSchema = yup.object().shape({
        upload_audio: yup.mixed().when([], {
            is: () => !edit, // only validate when NOT editing
            then: (schema) =>
                schema
                    .required("An audio file is required")
                    .test(
                        "fileSize",
                        `File size must be less than ${fileLimitInMB} MB`,
                        (value) => value && value.size <= fileLimitInMB * 1024 * 1024
                    )
                    .test(
                        "subscriptionSpace",
                        `Not enough subscription space left. Limit is ${subscriptionListFiltered?.total_space_in_mb} MB`,
                        (value) => value && (announcementSize + value.size) <= subscriptionListFiltered?.total_space_in_mb * 1024 * 1024
                    )
                    .test(
                        "fileType",
                        "Only audio files are allowed",
                        (value) => value && value.type.startsWith("audio/")
                    ),
            otherwise: (schema) => schema.notRequired(),
        }),
        filename: yup.string(),
    })

    const initialValues = {
        filename: announcementDetails?.filename || "",
    }

    function handleSubmit(values, action) {
        const filename =
            values.filename !== ""
                ? values.filename
                : values.upload_audio?.name
        const payload = {...values, filename}

        if (edit) {
            submitFormEdit(payload, jsonTime => {
                action.setSubmitting(false)
                navigate(-1)
            })
        } else {
            submitFormAdd(payload, jsonTime => {
                action.setSubmitting(false)
                navigate(-1)
            })
        }
    }

    return <Stack>
        <AdminUserAlert/>
        <OurClearAlert variant="danger" msg={errorAnDetails} onClear={clearErrorAnDetails}/>
        <OurClearAlert variant="danger" msg={errorAnSize} onClear={clearErrorAnSize}/>
        <OurClearAlert variant="danger" msg={errorSubListF} onClear={clearErrorSubListF}/>
        <OurClearAlert variant="danger" msg={fileLimitError} onClear={fileLimitClearError}/>

        <PageTitle title="Annoucement Details">{edit ? "Edit" : "Add"} announcement.</PageTitle>

        {loading && <div>Loading</div>}

        <Formik validationSchema={validationSchema} onSubmit={handleSubmit} initialValues={initialValues} enableReinitialize={true} validateOnChange={true}>
            {({isSubmitting, resetForm, values, setSubmitting}) => (
                <FormikForm>

                    <OurClearAlert variant="danger" msg={errorEdit} onClear={() => {
                        clearErrorEdit()
                        setSubmitting(false)
                    }}/>
                    <OurClearAlert variant="danger" msg={errorAdd} onClear={() => {
                        clearErrorAdd()
                        setSubmitting(false)
                    }}/>

                    <WhiteCard>
                        <AvailableSpaceBar announcementSize={announcementSize} abSubscription={subscriptionListFiltered?.total_space_in_mb * 1024 * 1024}
                                           article_title={subscriptionListFiltered?.article_title} remaining_days={subscriptionListFiltered?.remaining_days}/>
                    </WhiteCard>


                    <FileUpload name="upload_audio" label="Upload audio file" className="flex-grow-1 my-2"/>

                    <SingleText name="filename" label="Audio name" placeholder={values.upload_audio && values.upload_audio.name}
                                tip="Keep or change the file name."/>


                    <Stack direction="horizontal" gap="2" className="py-3 justify-content-end">
                        <Button as={Link} variant="link" to={-1}>Go back</Button>
                        <Button type="submit" variant="primary" disabled={isSubmitting}>Save</Button>
                    </Stack>

                </FormikForm>
            )}
        </Formik>
    </Stack>
}
